import Component from '../component';

export default class QuickSubmit extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);

    if (this.$element.disabled) return;

    this.$formElement = this.$element.closest('form');

    this.bindEvents();
  }

  bindEvents() {
    this.handleKeyDown = this.handleKeyDown.bind(this);

    this.$element.on('keydown.QuickSubmit', this.handleKeyDown);
  }

  unbindEvents() {
    this.$element.off('keydown.QuickSubmit', this.handleKeyDown);
  }

  handleKeyDown(event) {
    const ENTER_KEYCODE = 13;

    if (event.which === ENTER_KEYCODE && (event.metaKey || event.ctrlKey)) {
      this.$formElement.submit();
    }
  }
}
